export default __webpack_public_path__ + "51356bcb63a889e504abd6b5bb907823.svg";